<template>
	<div class="foot_body">
		<div class="connect_box">
			<div class="connect_msg">
				<div>联系我们：</div>
				<div class="tel">18080135130</div>
				<div class="service_time">仅限中国服务时间 09:00 - 18:00</div>
			</div>
			<img class="connect_img" src="@/assets/ewm.png" alt="" />
		</div>
		<div class="version_text">衡运维版权所有        蜀ICP备2025137145号-1  川公网安备51015602001263号</div>
	</div>
</template>

<script>
	export default{
		
	}
</script>

<style scope>
	.foot_body{
		width: 100%;
		background: #313131;
		color:rgba(255, 255, 255, 0.6);
		font-size: 20px;
	}
	.connect_box{
		overflow: hidden;
		padding:60px 200px 82px 200px;
	}
	.connect_msg{
		float: left;
	}
	.tel{font-size:30px;padding-top:20px;padding-bottom: 6px;}
	.service_time{font-size: 16px;}
	.connect_img{width:116px;float: right;}
	.version_text{
		font-size: 18px;
		border-top: 1px solid rgba(255, 255, 255, 0.1);;
		padding:17px 200px;
	}
</style>